/*
    Copyright 2020 Lauren Gyldenlove.
    This file is part of Duelmaster.

    Duelmaster is free software: you can redistribute it and/or modify
    it under the terms of the GNU General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    (at your option) any later version.

    Duelmaster is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU General Public License for more details.

    You should have received a copy of the GNU General Public License
    along with Foobar.  If not, see <https://www.gnu.org/licenses/>.
 */

import React from 'react';
import { createStyles, makeStyles } from '@material-ui/styles';
import { Paper } from '@material-ui/core';
import { Theme } from '@material-ui/core';

const styles = (theme: Theme) => 
    createStyles({
        monster: {
            fontSize: "150%",
            padding: "0.5em",
            textAlign: "center",
            border: "5px solid #EACC70",
            borderRadius: "5px",
            background: "#773A10",
            color: "#fff",
            height: "8.6em",
            width: "5.9em",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            margin: "0.5em auto",
            [theme.breakpoints.down('md')]: {
                fontSize: "100%"
            }
        },
        monsterInner: {
            display: "inline-flex",
            justifyContent: "center",
            alignItems: "center",
            whiteSpace: "nowrap",
            overflow: "visible",
            background: "#3D1D09",
            borderRadius: "50%",
            height: "66%",
            width: "50%"
        },
    });
const useStyles = makeStyles(styles);

export interface MonsterProps {
    monsterStrength: number
}

export const Monster = (props: MonsterProps) => {
    const classes = useStyles();

    return (
        <Paper className={classes.monster}>
            <div className={classes.monsterInner}>
                {props.monsterStrength}
            </div> 
        </Paper>
    );
};
